import { all, fork, putResolve, select, take } from 'redux-saga/effects';

import { login, RE_LOGIN } from 'app/redux/actions/auth';

import { getClientInfo, getFreebets } from './actions';
import { clientId } from './selectors';


function* putRequestAccount() {
  try {
    yield all([
      putResolve(getClientInfo()),
      putResolve(getFreebets()),
    ]);
  }
  catch (err) {
    if (err.status !== 401) {
      console.error('account request failed', err.message); // >>>
    }
  }
}

export default function* accountRequestSaga() {
  // Было закоментировано в связи с задачей CP-1865, т.к на первый взгляд не имеет смысла, если в дальнейшем не вызовет проблем - удалить
  // const token = yield select(clientId);
  // if (!token) {
  //   yield fork(putRequestAccount);
  // }

  while (true) {
    yield take([login.fulfilled.toString(), RE_LOGIN]);
    yield fork(putRequestAccount);
  }
}
